<template>
<div class="chapter">
<div class="inner_page">
<p class="copyt">This edition published in 2018 by</p>
<p class="copy1">Pen &amp; Sword Military</p>
<p class="copy">An imprint of</p>
<p class="copy">Pen &amp; Sword Books Ltd.</p>
<p class="copy">47 Church Street</p>
<p class="copy">Barnsley</p>
<p class="copy">South Yorkshire</p>
<p class="copy">S70 2AS</p>
<p class="copy1">Copyright © Coda Publishing Ltd. 2018.</p>
<p class="copy">Published under licence by Pen &amp; Sword Books Ltd.</p>
<p class="copy1">ISBN: 9781473868526</p>
<p class="copy">eISBN: 9781473868540</p>
<p class="copy">Mobi ISBN: 9781473868533</p>
<p class="copy1">A CIP catalogue record for this book is available from the British Library.</p>
<p class="copy1">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.</p>
<p class="copy1">Pen &amp; Sword Books Ltd. incorporates the imprints of Pen &amp; Sword Aviation, Pen &amp; Sword Family History, Pen &amp; Sword Maritime, Pen &amp; Sword Military, Pen &amp; Sword Discovery, Pen &amp; Sword Politics, Pen &amp; Sword Atlas, Pen &amp; Sword Archaeology, Wharncliffe Local History, Wharncliffe True Crime, Wharncliffe Transport, Pen &amp; Sword Select, Pen &amp; Sword Military Classics, Leo Cooper, The Praetorian Press, Claymore Press, Remember When, Seaforth Publishing and Frontline Publishing</p>
<p class="copy1">For a complete list of Pen &amp; Sword titles please contact</p>
<p class="copy1">PEN &amp; SWORD BOOKS LIMITED</p>
<p class="copy">47 Church Street, Barnsley, South Yorkshire, S70 2AS, England</p>
<p class="copy">E-mail: <span class="weblink"><a href="mailto:enquiries@pen-and-sword.co.uk"><span class="underline">enquiries@pen-and-sword.co.uk</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.pen-and-sword.co.uk" target="_blank"><span class="underline">www.pen-and-sword.co.uk</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?3a86f993